// extracted by mini-css-extract-plugin
module.exports = {"languageSwitch":"language-switch-module--languageSwitch--gLac0","languageSwitchSignup":"language-switch-module--languageSwitchSignup--1pMOF"};